import {ILanguageState} from '@app/shared/models/language.model';
import {environment} from '@environments/environment';
import {createReducer, on} from '@ngrx/store';
import {getLanguagesSuccess, setLanguageFromHeaderEffect, setLanguageFromLanguageEffect} from './language.action';

const initialState: ILanguageState = {
  languages: [],
  selectedLanguage: environment.defaultLanguage,
};

export const languageReducer = createReducer(
  initialState,
  on(getLanguagesSuccess, (state, {languages}) => ({...state, languages})),
  on(setLanguageFromHeaderEffect, setLanguageFromLanguageEffect, (state, {languageId: selectedLanguage}) => ({
    ...state,
    selectedLanguage: selectedLanguage,
  }))
);
